import themeConfig from './themeConfig';
import dateConfig from './dataConfig';
import netConfig from './netConfig';
import { msIncomeAuthConfig } from './authConfig';
import * as routeConfig from './routeConfig';

export const { routerConfig } = routeConfig;

export {
  themeConfig,
  dateConfig,
  netConfig,
  msIncomeAuthConfig,
  routeConfig
};
